import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

// ----------------------------------------------------------------------

export default function UpdateLoading() {
	const { customConnectProps } = useContext(Context);

	const { translate } = useLocales();

	return (
		<Stack alignItems={"center"} sx={{ mx: 4, mb: 4 }}>
			<Iconify
				icon={"line-md:loading-twotone-loop"}
				color={customConnectProps?.theme?.colors.primary}
				width={100}
				height={100}
			/>
			<Typography sx={{ mt: 8 }} variant='subtitle2'>
				{customConnectProps?.updateToken
					? translate("connect_panel.init_update")
					: translate("connect_panel.init_restore")}
			</Typography>
		</Stack>
	);
}
